import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaughWink, faClock ,faCalendarAlt, faTachometerAlt, faCog, faWrench, faFolder, faChartArea, faTable, faBowlFood, faUser, faCartShopping, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/images/logo_italianrest_transparent.png';
import { UserContext } from '../contexts/UserContext';


const Footer = () => {
    const navigate = useNavigate();
    
  
  
    return (
    <div className="content cont-footer">
        <div className="row">
            <div className="col-md-3 mobile-hd">
                  <p className='footer-tl titre1-marg'>Liens utiles</p>
                <ul className='mt-3'>
                    <li className='mb-2'><Link className="link-footer"  to="https://chezpapy-pizza-narbonne.com/notre-histoire/">Notre histoire</Link></li>
                    {/* <li className='mb-2'><Link className="link-footer" to="https://chezpapy-pizza-narbonne.com/lequipe/">L’équipe</Link></li> */}
                         <li className='mb-2'><Link className="link-footer"  to="https://chezpapy-pizza-narbonne.com/menu/">Plats</Link></li>
                    <li className='mb-2'><Link className="link-footer" to="https://chezpapy-pizza-narbonne.com/contact-3/">Contact</Link></li>
                    <li className='mb-2'><Link className="link-footer"  to="https://chezpapy-pizza-narbonne.com/reservation/">Réserver une table</Link></li>
                    <li className='mb-2'><Link className="link-footer" to="/boutique">Vente à emporter</Link></li>
                   
                </ul>
            </div>

               <div className="col-md-3 desktop-hd">
                  <p className='footer-tl titre1-marg'>Restaurant</p>
                <ul className='mt-3'>
                    <li className='mb-2'><Link className="link-footer"  to="https://chezpapy-pizza-narbonne.com/notre-histoire/">Notre histoire</Link></li>
                    {/* <li className='mb-2'><Link className="link-footer" to="https://chezpapy-pizza-narbonne.com/lequipe/">L’équipe</Link></li> */}
                  
                    
                   
                </ul>
            </div>
               <div className="col-md-3 desktop-hd">
                  <p className='footer-tl titre1-marg'>Menu</p>
                <ul className='mt-3'>
                    <li className='mb-2'><Link className="link-footer"  to="https://chezpapy-pizza-narbonne.com/menu/">Plats</Link></li>
                    <li className='mb-2'><Link className="link-footer" to="https://chezpapy-pizza-narbonne.com/contact-3/">Contact</Link></li>
                  
                    
                   
                </ul>
            </div>
               <div className="col-md-3 desktop-hd">
                  <p className='footer-tl titre1-marg'>Réservation</p>
                <ul className='mt-3'>
                    <li className='mb-2'><Link className="link-footer"  to="https://chezpapy-pizza-narbonne.com/reservation/">Réserver une table</Link></li>
                    <li className='mb-2'><Link className="link-footer" to="/boutique">Vente à emporter</Link></li>
                  
                    
                   
                </ul>
            </div>
            <div className="col-md-3">
                <p className='footer-tl titre2-marg'>Où nous trouver</p>
                <p className="text-footer titre1-marg" >52, Boulevard Anatole France, Narbonne</p>
                <p className='footer-tl titre2-marg'>Téléphone</p>
                <p className="text-footer" >04 68 41 33 21</p>
              
            </div>
            
            <div className="col-md-12 mg-tp">
                 <Link className="" to="/admin">
                    <img className="logo-footer" src={logo} alt="Chez papy"/>
                     </Link>
                    <p className="text-footer text-center mt-3" >© 2025 <Link  to="https://digital-french-touch.com/">La Digitale French Touch. </Link></p>
                    <p className="link-footer text-center" >
                        <Link className="link-footer " to="https://chezpapy-pizza-narbonne.com/conditions-dutilisation/">Conditions d’utilisation | Politique de confidentialité</Link>
               
                </p>
            </div>
        </div>
    </div> 

);
};

export default Footer;